export default {
  namespaced: true,
  state: {
    openMenu: false,
    isVisibleSearch: false,
    isVisibleSavedViews: false,
    isVisibleTrackerTabsIcon: false,
    searchTxt: '',
    viewsListFilter: null,
    savedViewSelected: null,
    reloadAll: false
  },
  getters: {
    openMenu (state, getters) {
      return state.openMenu
    },
    isVisibleSearch (state, getters) {
      return state.isVisibleSearch
    },
    isVisibleSavedViews (state, getters) {
      return state.isVisibleSavedViews
    },
    isVisibleTrackerTabsIcon (state, getters) {
      return state.isVisibleTrackerTabsIcon
    },
    getSearchTxt (state, getters) {
      return state.searchTxt
    },
    getAvaibleViews (state, getters) {
      return state.viewsListFilter
    },
    getSavedSelectedView (state, getters) {
      return state.savedViewSelected
    },
    getReloadAll (state, getters) {
      return state.reloadAll
    }
  },
  mutations: {
    setOpenMenu: function (state, openMenu) {
      state.openMenu = openMenu
      if (openMenu) {
        state.isVisibleSavedViews = false
        state.isVisibleSearch = false
      }
    },
    setIsVisibleSearch: function (state, openSearch) {
      state.isVisibleSearch = openSearch
      if (openSearch) {
        state.openMenu = false
        state.isVisibleSavedViews = false
      }
    },
    setIsVisibleViews: function (state, openFilters) {
      state.isVisibleSavedViews = openFilters
      if (openFilters) {
        state.openMenu = false
        state.isVisibleSearch = false
      }
    },
    setIsVisibleTrackerTabsIcon: function (state, openTrackerTabs) {
      state.isVisibleTrackerTabsIcon = openTrackerTabs
    },
    setSearchTxt: function (state, searchValue) {
      state.searchTxt = searchValue
    },
    setAvailableViews: function (state, viewsSaved) {
      state.viewsListFilter = viewsSaved
    },
    setSavedViewSelected: function (state, viewsSelected) {
      state.savedViewSelected = viewsSelected
    },
    setReloadAll: function (state, reload) {
      state.reloadAll = reload
    },
    resetAll: function (state) {
      state.openMenu = false
      state.isVisibleSearch = false
      state.isVisibleSavedViews = false
    }
  }
}
